<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb1"></question-title>

      <div class="control mt1 video-responsive">
        <youtube
          :video-id="videoId()"
          :player-vars="{ start: startTime(), rel: 0, showinfo: 0 }"
        ></youtube>
      </div>

      <br />

      <next-button
        :id="question.id"
        :choice="choice"
        :hasAnswer="false"
      ></next-button>
    </div>
  </div>
</template>

<script>
import { getIdFromURL, getTimeFromURL } from "vue-youtube-embed";

import baseQuestion from "./baseQuestion";

export default {
  name: "video-instruction",

  methods: {
    videoId() {
      return getIdFromURL(this.question.fields[0].url);
    },
    startTime() {
      return getTimeFromURL(this.question.fields[0].url);
    }
  },

  mixins: [baseQuestion]
};
</script>

<style lang="scss">
.video-responsive {
  div {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
    border: 1px solid #d6bcbc;
    background: url(/static/play.png) center no-repeat;
    background-size: 50%;

    iframe {
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      position: absolute;
    }
  }
}
</style>
